const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000';

/** Live payment state derived from Polar during a sync, for the in-app banner. */
export interface PaymentIssue {
  /** Raw Polar subscription status ('active' | 'past_due' | 'unpaid' | 'canceled' | 'none' | 'lifetime' | …). */
  status: string;
  /** True when Polar has an actionable payment failure (past_due/unpaid) — show the banner. */
  pastDue: boolean;
  currentPeriodEnd: string | null;
  cancelAtPeriodEnd: boolean;
}

export interface SyncResult {
  subscriptionTier: 'free' | 'pro' | 'lifetime';
  polarCustomerId: string | null;
  subscriptionExpiresAt?: string | null;
  paymentIssue?: PaymentIssue;
  message?: string;
}

/**
 * Reconcile the user's subscription with Polar and return the resulting tier +
 * live payment status. Writes the DB server-side (self-heals stale rows), so
 * callers should refresh the session / subscription query afterwards.
 */
export async function syncSubscription(): Promise<SyncResult> {
  const response = await fetch(`${API_URL}/api/subscription/sync`, {
    credentials: 'include',
  });
  if (!response.ok) {
    throw new Error(`Subscription sync failed (${response.status})`);
  }
  return response.json();
}
